export default __webpack_public_path__ + "static/media/KZ.T.15.0798 black.3f50b831.svg";